<template>
	<div class="tb-drop-menu">
		<tool-menu-item v-for="it in items" :key="it.id" :item="it" :dir="dir" @action="itemAction"></tool-menu-item>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import ToolMenuItem from "@/ui/toolbar/ToolMenuItem.vue";
import {ToolbarMenuItems} from "@t/ui/Toolbar.ts";

const props = defineProps<{
	items: ToolbarMenuItems,
	dir: "left" | "right"
}>();
const emit = defineEmits(['action']);

function itemAction(id: string, arg?:any) {
	emit("action", id, arg);
}
</script>

<style>

</style>